export const permissions = {
  roles: {
    SUPER_ADMIN: 'SUPERADMIN',
    ADVISER: 'ADVISER',
    ADVISER_NOT_SECURE: 'ADVISER_NOT_SECURE',
    CLIENT_NOT_SECURE: 'CLIENT_NOT_SECURE',
    CLIENT: 'CLIENT',
  }
};
